import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { SanctionBody } from "../shared/types/common.type";

export interface SettingsState {
  sanctionBodiesList: SanctionBody[];
  currentCustomerId: number;
  currentUserId: number;
}

export const settingsInitialState: SettingsState = {
  currentCustomerId: 0,
  currentUserId: 0,
  sanctionBodiesList: [],
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: settingsInitialState,
  reducers: {
    updateSanctionBodies: (state, action: PayloadAction<SanctionBody[]>) => {
      return {
        ...state,
        sanctionBodiesList: [...state.sanctionBodiesList, ...action.payload],
      };
    },
  },
});

export const { updateSanctionBodies } = settingsSlice.actions;

export default settingsSlice.reducer;
